import component from './SplitRenderingHere';

export default component;
